import React, { useState, useEffect, useRef, useContext } from "react";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import ScatterChart from "../../../components/organisms/ScatterChart/ScatterChart"
import BubbleChart from "../../../components/organisms/BubbleChart/BubbleChart";
import LollipopChart from "../../../components/organisms/LollipopChart/LollipopChart";
import {
  simpleFetch,
  clearHooks,
  normalizeDistributionData,
  requestAxis, mergeArrayObjects,
  localHour,
  buildOnLoad,
  nameValidation,
  validRange,
  yearList,
  refDistrictHistogram,
} from "../../../utils/helpsers";
import MapView from "../../../components/organisms/MapView/MapView";
import Button from "@mui/material/Button";
import RangeSlider from "../../../components/molecules/RangeSlider/RangeSlider";
import ApaReferenceAccordion from "../../../components/molecules/ApaReference/ApaReferenceAccordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LayoutPage from "../../../templates/Layout/LayoutPage";
import Tooltip from "@mui/material/Tooltip";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import ReportButtons from "../../../components/organisms/BugReport/ReportButtons";
import BoardBuilder from "../../../components/organisms/BoardBuilder/BoardBuilder";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import useQuery from "../../../utils/userLocation";
import EditIcon from "@mui/icons-material/Edit";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import Grid from "@mui/material/Grid";
import axios from "axios";
import Snackbar from '@mui/material/Snackbar';
import { TokenContext } from "../../../utils/Context";
import Box from '@mui/material/Box';
import {
  BoardActionsStyles, BoardGroupCounter,
  InputEditStyles,
  MenuBoxStyles,
} from "../DistrictInsight/DistrictInsight.styles";
import { ExplorerStyles } from "./DistrictExplorer.styles";
import Paper from "@mui/material/Paper";
import TooltipCustom from "../../../components/molecules/CustomTooltip/CustomTooltip";
import SaveBoardForm from "../../../components/molecules/SaveBoard/SaveBoardForm";
import Alert from "@mui/material/Alert";
import GroupDisplay from "../../../components/molecules/GroupDisplay/GroupDisplay";

HighchartsMore(Highcharts)

function DistrictExplorer() {
  // User session metadata and data
  const { user } = useAuth0();
  const metadata = user[`${process.env.REACT_APP_AUTH0_KEY}/district`];
  const enabledShare = metadata.enable_share;
  const enabledHealthBenefits = metadata.enable_hbenefits;

  // User session token
  const { userToken } = useContext(TokenContext);

  const navigate = useNavigate();
  const query = useQuery();

  // Object value/label from select component
  const [districtInfo, setDistrictInfo] = useState();
  const [groupInfo, setGroupInfo] = useState();
  // Radio selected value
  const [groupType, setGroupType] = useState();

  const [groupCount, setGroupCount] = useState();

  const [DomainGroup, setDomainGroup] = useState([]);
  const [axisX, setAxisX] = useState(null);
  const [xFooterData, setXFooterData] = useState();
  const [axisY, setAxisY] = useState(null);
  const [yFooterData, setYFooterData] = useState();
  const [axisZ, setAxisZ] = useState(null);
  const [zFooterData, setZFooterData] = useState();

  const [scatterX, setScatterX] = useState();
  const [scatterY, setScatterY] = useState();
  const [scatterZ, setScatterZ] = useState();
  const [scatterData, setScatterData] = useState();
  const [bubbleData, setBubbleData] = useState();
  const [irns, setIrns] = useState();
  const [histogramX, setHistogramX] = useState();
  const [histogramY, setHistogramY] = useState();
  const [histogramZ, setHistogramZ] = useState();
  const [varZEnabled, setVarZEnabled] = useState(false);

  const [year, setYear] = useState({});

  const [boardData, setBoardData] = useState();
  const [existingBoard, setExistingBoard] = useState();

  //Data for Map
  const [mapViewData, setMapViewData] = useState();

  // X-Y-Z Ranges Group
  const [statsVariableX, setStatsVariableX] = useState();
  const [statsVariableY, setStatsVariableY] = useState();
  const [statsVariableZ, setStatsVariableZ] = useState();

  // Range set with slider component
  const [xCustomRange, setXCustomRange] = useState();
  // Range set with slider component
  const [yCustomRange, setYCustomRange] = useState();
  // Range set with slider component
  const [zCustomRange, setZCustomRange] = useState();

  // Boards saved by the user.
  const [boardsName, setBoardsName] = useState(null);
  const [getUserBoards, setGetUserBoards] = useState(true)

  // Status report message.
  const [status, setStatus] = useState();
  const [displayStatus, setDisplayStatus] = useState(false);

  const handleFilter = () => {
    setBtnFilter(null);
  };

  // Set the board version
  const setBoardVersion = (
    groupCountVar,
    yearVar,
    irnsVar,
    groupTypeVar,
    groupInfoVar,
    xCustomRangeVar,
    axisXVar,
    statsVariableXVar,
    histogramXVar,
    yCustomRangeVar,
    axisYVar,
    statsVariableYVar,
    histogramYVar,
    zCustomRangeVar,
    axisZVar,
    statsVariableZVar,
    histogramZVar
  ) => {
    setGroupCount(groupCountVar);
    setYear(yearVar);
    setIrns(irnsVar);
    setGroupType(groupTypeVar);
    setGroupInfo(groupInfoVar);
    // X axis data.
    setXCustomRange(xCustomRangeVar);
    setAxisX(axisXVar);
    setStatsVariableX(statsVariableXVar);
    setHistogramX(histogramXVar);
    // Y axis data.
    setYCustomRange(yCustomRangeVar);
    setAxisY(axisYVar);
    setStatsVariableY(statsVariableYVar);
    setHistogramY(histogramYVar);
    // Z axis data.
    setZCustomRange(zCustomRangeVar);
    setAxisZ(axisZVar);
    setStatsVariableZ(statsVariableZVar);
    setHistogramZ(histogramZVar);
  };

  const [btnFilter, setBtnFilter] = useState(null);
  const [btnSaved, setBtnSaved] = useState(null);
  const [btnShared, setBtnShared] = useState(null);

  const openFilters = Boolean(btnFilter);
  const openSaved = Boolean(btnSaved);
  const openShared = Boolean(btnShared);

  const [activeVersion, setActiveVersion] = useState(null);
  const [lastVersion, setLastVersion] = useState(null);
  const [sortedVersions, setSortedVersions] = useState([]);

  useEffect(() => {
    if (!lastVersion && existingBoard) {
      let unsorted = Object.keys(existingBoard.data);
      unsorted = unsorted.map((version) => {
        let label =
          version === existingBoard.data[version]["created_at"]
            ? `${localHour(version)}`
            : `${version} - ${localHour(
              existingBoard.data[version]["created_at"]
            )}`;
        return {
          label: label,
          value: version,
          datetime: new Date(existingBoard.data[version]["created_at"]),
        };
      });
      let sortedDates = unsorted.sort((a, b) => b.datetime - a.datetime);

      let lastVersion = sortedDates[0];

      setSortedVersions(sortedDates);
      setActiveVersion(lastVersion);
      if (lastVersion) {
        boardVersion.current = lastVersion.value;
      }
      setLastVersion(lastVersion);
    }
  }, [existingBoard, lastVersion]);

  const clickFilters = (event) => {
    setBtnFilter(event.currentTarget);
  };

  const closeFilters = () => {
    setBtnFilter(null);
  };

  const clickSaved = (event) => {
    setBtnSaved(event.currentTarget);
  };

  const closeSaved = () => {
    setBtnSaved(null);
  };

  const clickShared = (event) => {
    setBtnShared(event.currentTarget);
  };

  const closeShared = () => {
    setBtnShared(null);
  };

  const [activeUser, setActiveUser] = useState([]);
  const [users, setUsers] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const [usersFormat, setUsersFormat] = useState([]);
  const [shareWith, setShareWith] = useState([]);

  const [action, setAction] = useState();

  const shareWithUsers = () => {
    if (existingBoard) {
      if (shareWith.length === 0) {
        setDisplayStatus(true);
        setStatus({
          type: 'error',
          message: "The field can't be empty"
        });
        closeShared();
      } else {
        let uuid = existingBoard.uuid;
        let bodyJson = existingBoard;

        bodyJson["available_users_share"] = shareWith;

        bodyJson = JSON.stringify(bodyJson);

        fetch(
          `${process.env.REACT_APP_API_URL}/custom_boards?uuid=eq.${uuid}`,
          {
            method: "PUT",
            headers: {
              "ngrok-skip-browser-warning": true,
              Authorization: "Bearer " + userToken,
              "Content-Type": "application/json",
            },
            body: bodyJson,
          }
        ).then((response) => {
          setDisplayStatus(true);
          setStatus({
            type: 'success',
            message: 'Board shared successfully'
          });
          closeShared();
        });
      }
    }
  };

  useEffect(() => {
    if (usersFormat.length === 0) {
      async function getGroups() {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/groups`,
          {
            headers: {
              "ngrok-skip-browser-warning": true,
            },
          }
        );
        return response.data;
      }

      getGroups().then((groups) => {
        setUserGroups(groups);
        axios
          .get(`${process.env.REACT_APP_API_URL}/users`, {
            headers: {
              "ngrok-skip-browser-warning": true,
            },
          })
          .then((res) => {
            setUsers(res.data);

            let currentUser = res.data.find((element, index) => {
              let valid = false;

              if (element.email === user.email) {
                valid = true;
              }

              return valid;
            });

            setActiveUser(currentUser);
          });

        let filteredUsers = users.filter((userF) =>
          userF.group_id === activeUser.group_id ? userF : false
        );
        let usersFormatted = filteredUsers.map((userF) => {
          let userGroup = userGroups.find(
            (userGroup) => userGroup.id === userF.group_id
          );
          let filteredResult = null;
          if (userF && userGroup) {
            filteredResult = {
              value: userF.email,
              label: userF.name + " @ " + userGroup.name,
            };
          }
          return filteredResult;
        });
        setUsersFormat(usersFormatted);
      });
    }
  }, [activeUser.group_id, user.email, userGroups, users, usersFormat.length]);

  const handleChange = (selection) => {
    if (existingBoard.data[selection.value].histogramsData) {
      setActiveVersion(selection);
      // Cleaning group info hook.
      let selectedVersion = existingBoard.data[selection.value];
      setBoardVersion(
        selectedVersion.groupCount,
        selectedVersion.year,
        selectedVersion.irns,
        selectedVersion.groupType,
        selectedVersion.groupInfo,
        null,
        null,
        selectedVersion.statsVariables.statsVariableX,
        selectedVersion.histogramsData.histogramX,
        null,
        null,
        selectedVersion.statsVariables.statsVariableY,
        selectedVersion.histogramsData.histogramY,
        null,
        null,
        selectedVersion.statsVariables.statsVariableZ,
        selectedVersion.histogramsData.histogramZ
      );

      setTimeout(
        () =>
          setBoardVersion(
            selectedVersion.groupCount,
            selectedVersion.year,
            selectedVersion.irns,
            selectedVersion.groupType,
            selectedVersion.groupInfo,
            selectedVersion.sliderRanges.xRange,
            selectedVersion.axisVars.axisX,
            selectedVersion.statsVariables.statsVariableX,
            selectedVersion.histogramsData.histogramX,
            selectedVersion.sliderRanges.yRange,
            selectedVersion.axisVars.axisY,
            selectedVersion.statsVariables.statsVariableY,
            selectedVersion.histogramsData.histogramY,
            selectedVersion.sliderRanges.zRange,
            selectedVersion.axisVars.axisZ,
            selectedVersion.statsVariables.statsVariableZ,
            selectedVersion.histogramsData.histogramZ
          ),
        100
      );
    }
  };

  // Getting the boards  created by the current user.
  useEffect(() => {
    if (userToken && getUserBoards) {
      axios.get(
        `${process.env.REACT_APP_API_URL}/custom_boards?created_by=eq.${encodeURIComponent(user.email)}`,
        {
          headers: {
            'ngrok-skip-browser-warning': true
          }
        }
      ).then((res) => {
        setGetUserBoards(false)
        setBoardsName(res.data);
      });
    }
  }, [user.email, userToken, getUserBoards]);

  const changeName = (e) => {
    e.preventDefault()
    let isValidName = nameValidation({ arr: boardsName, name: boardName.current, key: 'label' });

    if (existingBoard && isValidName) {
      let uuid = existingBoard.uuid;
      let bodyJson = existingBoard;

      bodyJson.label = boardName.current;
      bodyJson = JSON.stringify(bodyJson);

      axios(`${process.env.REACT_APP_API_URL}/custom_boards?uuid=eq.${uuid}`, {
        method: "PUT",
        headers: {
          "ngrok-skip-browser-warning": true,
          Authorization: "Bearer " + userToken,
          "Content-Type": "application/json",
        },
        data: bodyJson,
      }
      ).then(() => {
        setAction("");
        setGetUserBoards(true);
        setDisplayStatus(true);
        setStatus({
          type: 'success',
          message: 'The New Board was successfully renamed'
        });
      }).catch(err => {
        setDisplayStatus(true);
        setStatus({
          type: 'error',
          message: err.message
        });
      });
    } else if (!isValidName) {
      setDisplayStatus(true);
      setStatus({
        type: 'error',
        message: 'Board name is already in use'
      });
    }
  };

  const changeVersion = (e) => {
    e.preventDefault();
    let isValidName = nameValidation({ arr: sortedVersions, name: boardVersion.current, key: 'value' });

    if (existingBoard && isValidName) {
      let uuid = existingBoard.uuid;
      let bodyJson = existingBoard;

      if (action === "edit-version" && existingBoard.data[activeVersion.value]["done_by"] === user.email) {
        bodyJson.data[boardVersion.current] = bodyJson.data[activeVersion.value];
        if (boardVersion.current !== activeVersion.value) {
          delete bodyJson.data[activeVersion.value];
        }
      }

      bodyJson = JSON.stringify(bodyJson);

      axios(`${process.env.REACT_APP_API_URL}/custom_boards?uuid=eq.${uuid}`, {
        method: "PUT",
        headers: {
          "ngrok-skip-browser-warning": true,
          Authorization: "Bearer " + userToken,
          "Content-Type": "application/json",
        },
        data: bodyJson,
      }).then(() => {
        setDisplayStatus(true);
        setStatus({
          type: 'success',
          message: 'The Board Version was successfully renamed'
        });
        setTimeout(() => window.location.reload(), 1000);
      }).catch(err => {
        setDisplayStatus(true);
        setStatus({
          type: 'error',
          message: err.message
        });
      });
    } else if (!isValidName) {
      setDisplayStatus(true);
      setStatus({
        type: 'error',
        message: 'Version name is already in use'
      });
    }
  }

  const boardName = useRef("");
  const boardVersion = useRef("");

  // Reference district request.
  useEffect(() => {
    if (metadata) {
      const userSessionType = metadata.hasOwnProperty("sessionType")
        ? metadata.sessionType
        : "forbidden";

      switch (userSessionType) {
        case "district-access":
          window.localStorage.setItem("session-type", "district-access");
          break;
        case "full-access":
          window.localStorage.setItem("session-type", "full-access");
          break;
        case "multiple-district-access":
          window.localStorage.setItem(
            "session-type",
            "multiple-district-access"
          );
          break;
        case "forbidden":
          navigate("/AccessDenied", { replace: true });
          break;
        default:
          navigate("/AccessDenied", { replace: true });
          break;
      }
    } else {
      navigate("/AccessDenied", { replace: true });
    }
  }, [navigate, user, metadata]);

  /**
   * Range selectors data request.
   * On change X axis variable, the range slider data will be the variable historical related with district's in the groups.
   */
  useEffect(() => {
    if (axisX && !xCustomRange) {
      let splitLD = axisX.value_var.split('__');
      let variable = axisX.value_var;

      setStatsVariableX();

      if (splitLD.length > 1 && enabledHealthBenefits) { 
        variable = splitLD[0];
        let planNum = splitLD[1];
        let planType = splitLD[2];

        simpleFetch(
          `${process.env.REACT_APP_API_URL}/rpc/hvd_stats_health?_var=${variable}&_irn=${districtInfo.value}&_irns=${irns}&_year=${year.value}&_plannum=${planNum}&_plantype=${planType}`
        ).then((data) =>
          setTimeout(() => {
            setStatsVariableX([data[0].min_var, data[0].max_var]);
            setXCustomRange([data[0].min_var, data[0].max_var]);
          }, 10)
        );
      } else {
        simpleFetch(
          `${process.env.REACT_APP_API_URL}/rpc/hvd_stats?_var=${variable}&_irn=${districtInfo.value}&_irns=${irns}&_year=${year.value}`
        ).then((data) =>
          setTimeout(() => {
            setStatsVariableX([data[0].min_var, data[0].max_var]);
            setXCustomRange([data[0].min_var, data[0].max_var]);
          }, 10)
        );
      }

      // Set distribution data for X axis histogram chart.
      normalizeDistributionData(
        {
          varName: axisX.value_var,
          varIrn: districtInfo.value,
          irns: irns,
          hook: setXFooterData,
          year: year.value,
        },
        userToken
      );
    }
  }, [axisX, districtInfo, irns, year, xCustomRange, userToken, enabledHealthBenefits]);

  /**
   * Range selectors data request.
   * On change Y axis variable, the range slider data will be the variable historical related with district's in the groups.
   */
  useEffect(() => {
    if (axisY && !yCustomRange) {
      let splitLD = axisY.value_var.split('__');
      let variable = axisY.value_var;

      setStatsVariableY();

      if (splitLD.length > 1 && enabledHealthBenefits) {
        variable = splitLD[0];
        let planNum = splitLD[1];
        let planType = splitLD[2];

        simpleFetch(
          `${process.env.REACT_APP_API_URL}/rpc/hvd_stats_health?_var=${variable}&_irn=${districtInfo.value}&_irns=${irns}&_year=${year.value}&_plannum=${planNum}&_plantype=${planType}`
        ).then((data) =>
          setTimeout(() => {
            setStatsVariableY([data[0].min_var, data[0].max_var]);
            setYCustomRange([data[0].min_var, data[0].max_var]);
          }, 10)
        );
      } else {
        simpleFetch(
          `${process.env.REACT_APP_API_URL}/rpc/hvd_stats?_var=${axisY.value_var}&_irn=${districtInfo.value}&_irns=${irns}&_year=${year.value}`
        ).then((data) =>
          setTimeout(() => {
            setStatsVariableY([data[0].min_var, data[0].max_var]);
            setYCustomRange([data[0].min_var, data[0].max_var]);
          }, 10)
        );
      }
      // Set distribution data for Y axis histogram chart.
      normalizeDistributionData(
        {
          varName: axisY.value_var,
          varIrn: districtInfo.value,
          irns: irns,
          hook: setYFooterData,
          year: year.value,
        },
        userToken
      );
    }
  }, [axisY, districtInfo, irns, year, yCustomRange, userToken, enabledHealthBenefits]);

  /**
   * Range selectors data request.
   * On change Z axis variable, the range slider data will be the variable historical related with district's in the groups.
   */
  useEffect(() => {
    if (axisZ && !zCustomRange) {
      let splitLD = axisZ.value_var.split('__');
      let variable = axisZ.value_var;

      setStatsVariableZ();

      if (splitLD.length > 1 && enabledHealthBenefits) {
        variable = splitLD[0];
        let planNum = splitLD[1];
        let planType = splitLD[2];

        simpleFetch(
          `${process.env.REACT_APP_API_URL}/rpc/hvd_stats_health?_var=${variable}&_irn=${districtInfo.value}&_irns=${irns}&_year=${year.value}&_plannum=${planNum}&_plantype=${planType}`
        ).then((data) =>
          setTimeout(() => {
            setStatsVariableZ([data[0].min_var, data[0].max_var]);
            setZCustomRange([data[0].min_var, data[0].max_var]);
          }, 10)
        );
      } else {
        simpleFetch(
          `${process.env.REACT_APP_API_URL}/rpc/hvd_stats?_var=${axisZ.value_var}&_irn=${districtInfo.value}&_irns=${irns}&_year=${year.value}`
        ).then((data) =>
          setTimeout(() => {
            setStatsVariableZ([data[0].min_var, data[0].max_var]);
            setZCustomRange([data[0].min_var, data[0].max_var]);
          }, 10)
        );
      }
      // Set distribution data for Y axis histogram chart.
      normalizeDistributionData(
        {
          varName: axisZ.value_var,
          varIrn: districtInfo.value,
          irns: irns,
          hook: setZFooterData,
          year: year.value,
        },
        userToken
      );
    }
  }, [axisZ, districtInfo, irns, year, zCustomRange, userToken, enabledHealthBenefits]);

  const updateRanges = (newRange, hook) => {
    hook(newRange);
  };

  /* TODO: Remove code once confirmed the boards works correctly */
  // useEffect(() => {
  //   let year_value = year.value ? year.value : 2020;
  //   if (year.value === 'MCD') {
  //     simpleFetch(
  //       `${process.env.REACT_APP_API_URL}/mcd_source_variable?dwh_table=neq.health_insurance_readable&visible=eq.true&order=label.asc`
  //     ).then((data) => {
  //       setDomainGroup(data);
  //     });
  //   } else {
  //     simpleFetch(
  //       `${process.env.REACT_APP_API_URL}/hvd_source_variable?file_year=eq.${year_value}&dwh_table=neq.health_insurance_readable&visible=eq.true&order=label.asc`
  //     ).then((data) => {
  //       setDomainGroup(data);
  //     });
  //   }
  // }, [year]);

  // Getting group count and adding district selected irn to irn's group
  useEffect(() => {
    if (groupInfo && districtInfo) {
      setDomainGroup([]);
      let domainData = [];
      /** TODO check if use only boarData improves the hook management **/
      let year_value = boardData?.year.value ? boardData?.year.value : 2020;
      if (boardData?.year.value === 'MCD') {
        simpleFetch(
          `${process.env.REACT_APP_API_URL}/mcd_source_variable_contracts?dwh_table=neq.health_insurance_readable&irn=eq.${districtInfo.value}&visible=eq.true&order=label.asc`
        ).then((data) => {
          domainData = data?.map(item => ({ ...item, label: `${item.label} (${item.available_years[0]})` }))
          setDomainGroup(domainData);
        }).then(() => {
          if (enabledHealthBenefits) {
            simpleFetch(
              `${process.env.REACT_APP_API_URL}/mcd_sv_health?erirn_employer_ein=eq.${districtInfo.value}&visible=eq.true&order=label.asc`
            ).then((data) => {
              setDomainGroup([...domainData, ...data])
            })
          }});
      } else {
        simpleFetch(
          `${process.env.REACT_APP_API_URL}/hvd_source_variable?file_year=eq.${year_value}&dwh_table=neq.health_insurance_readable&visible=eq.true&order=label.asc`
        ).then((data) => setDomainGroup(data))
          .then(() => {
            if (enabledHealthBenefits) {
            simpleFetch(
              `${process.env.REACT_APP_API_URL}/hvd_sv_health?file_year=eq.${year_value}&erirn_employer_ein=eq.${districtInfo.value}&visible=eq.true&order=label.asc`
            ).then((data) => setDomainGroup((previousData) => previousData.concat(data)))
          }});
      }

      // Getting group count.
      if (groupType.value === "custom_groups") {
        let varKey = Object.keys(groupInfo.custom_ranges).length;
        let varData = groupInfo.custom_ranges[`var${varKey}`];
        setGroupCount(varData.districtsCount);
        setIrns([...varData.irns, districtInfo.value]);
      } else if (groupType.value === "custom_boards") {
        setBoardVersion(
          groupInfo.data.groupCount,
          groupInfo.data.year,
          groupInfo.data.irns,
          groupType,
          groupInfo,
          groupInfo.data.sliderRanges.xRange,
          groupInfo.data.axisVars.axisX,
          groupInfo.data.statsVariables.statsVariableX,
          groupInfo.data.histogramsData.histogramX,
          groupInfo.data.sliderRanges.yRange,
          groupInfo.data.axisVars.axisY,
          groupInfo.data.statsVariables.statsVariableY,
          groupInfo.data.histogramsData.histogramY,
          groupInfo.data.sliderRanges.zRange,
          groupInfo.data.axisVars.axisZ,
          groupInfo.data.statsVariables.statsVariableZ,
          groupInfo.data.histogramsData.histogramZ
        );
      } else {
        if (!query.get("shared")) {
          let mergeIrns = (boardData.irns).concat(", ", districtInfo.value);
          setIrns(mergeIrns)
        }
      }
    }
  }, [groupInfo, districtInfo, groupType, year, query, boardData, boardData?.year, enabledHealthBenefits]);

  /**
   * Updating X axis histogram chart.
   */
  useEffect(() => {
    let histogramXData = { categories: [], data: [], district: {} };

    if (axisX && irns) {
      let splitLD = axisX.value_var.split('__');
      let variable = axisX.value_var;

      // X select data
      if (splitLD.length > 1) {
        variable = splitLD[0];
        let planNum = splitLD[1];
        let planType = splitLD[2];

        if (year.value === 'MCD' && enabledHealthBenefits) {
          fetch(
            `${process.env.REACT_APP_API_URL}/mcd_hb_tabloide?select=irn,x:${variable},district_name,irn&irn=in.(${irns})&${variable}=not.is.null&plannum=eq.${planNum}&q13_plantype_p7q3=eq.${planType}&order=${variable}.desc`,
            {
              headers: {
                Authorization: "Bearer " + userToken,
                "ngrok-skip-browser-warning": true,
              },
            }
          )
            .then((response) => {
              setHistogramX("loading");
              return response.json();
            })
            .then((data) =>
              data.forEach((item) => {
                histogramXData["categories"].push(item.district_name);
                if (item.irn === districtInfo.value) {
                  histogramXData["data"].push(refDistrictHistogram(item.x, data));
                  histogramXData["district"] = item;
                } else {
                  histogramXData["data"].push(item.x);
                }
              })
            )
            .then(() => setHistogramX(histogramXData))
            .catch(() => setHistogramX("no-data"));
        } else if (enabledHealthBenefits) {
          fetch(
            `${process.env.REACT_APP_API_URL}/health_insurance_readable?select=irn,x:${variable},district_name,irn&irn=in.(${irns})&file_year=eq.${year.value}&${variable}=not.is.null&plannum=eq.${planNum}&q13_plantype_p7q3=eq.${planType}&order=${variable}.desc`,
            {
              headers: {
                Authorization: "Bearer " + userToken,
                "ngrok-skip-browser-warning": true,
              },
            }
          )
            .then((response) => {
              setHistogramX("loading");
              return response.json();
            })
            .then((data) =>
              data.forEach((item) => {
                histogramXData["categories"].push(item.district_name);
                if (item.irn === districtInfo.value) {
                  histogramXData["data"].push(refDistrictHistogram(item.x, data));
                  histogramXData["district"] = item;
                } else {
                  histogramXData["data"].push(item.x);
                }
              })
            )
            .then(() => setHistogramX(histogramXData))
            .catch(() => setHistogramX("no-data"));
        }
      } else {
        if (year.value === 'MCD') {
          fetch(
            `${process.env.REACT_APP_API_URL}/mcd_tabloide?select=irn,x:${axisX.value_var},year_x:${axisX.value_var}_yr,district_name,irn&irn=in.(${irns})&${axisX.value_var}=not.is.null&order=${axisX.value_var}.desc`,
            {
              headers: {
                Authorization: "Bearer " + userToken,
                "ngrok-skip-browser-warning": true,
              },
            }
          )
            .then((response) => {
              setHistogramX("loading");
              return response.json();
            })
            .then((data) =>
              data.forEach((item) => {
                let distinct_year = yearList[1].value === item.year_x ? '' : ` (${item.year_x})`;

                histogramXData["categories"].push(`${item.district_name}${distinct_year}`);
                if (item.irn === districtInfo.value) {
                  histogramXData["data"].push(refDistrictHistogram(item.x, data));
                  histogramXData["district"] = item;
                } else {
                  histogramXData["data"].push(item.x);
                }
              })
            )
            .then(() => setHistogramX(histogramXData))
            .catch(() => setHistogramX("no-data"));
        }
        else {
          if (year.value === 'MCD') {
            fetch(
              `${process.env.REACT_APP_API_URL}/mcd_tabloide?select=irn,x:${axisX.value_var},year_x:${axisX.value_var}_yr,district_name,irn&irn=in.(${irns})&${axisX.value_var}=not.is.null&order=${axisX.value_var}.desc`,
              {
                headers: {
                  Authorization: "Bearer " + userToken,
                  "ngrok-skip-browser-warning": true,
                },
              }
            )
              .then((response) => {
                setHistogramX("loading");
                return response.json();
              })
              .then((data) =>
                data.forEach((item) => {
                  let distinct_year = yearList[1].value === item.year_x ? '' : ` (${item.year_x})`;

                  histogramXData["categories"].push(`${item.district_name}${distinct_year}`);
                  if (item.irn === districtInfo.value) {
                    histogramXData["data"].push(refDistrictHistogram(item.x, data));
                    histogramXData["district"] = item;
                  } else {
                    histogramXData["data"].push(item.x);
                  }
                })
              )
              .then(() => setHistogramX(histogramXData))
              .catch(() => setHistogramX("no-data"));
          } else {
            fetch(
              `${process.env.REACT_APP_API_URL}/hvd_tabloide?select=irn,x:${axisX.value_var},district_name,irn&irn=in.(${irns})&file_year=eq.${year.value}&${axisX.value_var}=not.is.null&order=${axisX.value_var}.desc`,
              {
                headers: {
                  Authorization: "Bearer " + userToken,
                  "ngrok-skip-browser-warning": true,
                },
              }
            )
              .then((response) => {
                setHistogramX("loading");
                return response.json();
              })
              .then((data) =>
                data.forEach((item) => {
                  histogramXData["categories"].push(item.district_name);
                  if (item.irn === districtInfo.value) {
                    histogramXData["data"].push(refDistrictHistogram(item.x, data));
                    histogramXData["district"] = item;
                  } else {
                    histogramXData["data"].push(item.x);
                  }
                })
              )
              .then(() => setHistogramX(histogramXData))
              .catch(() => setHistogramX("no-data"));
          }
        }
      }
    }
  }, [axisX, irns, districtInfo, year, userToken, query, enabledHealthBenefits]);

  /**
   * Updating Y axis histogram chart.
   */
  useEffect(() => {
    let histogramYData = { categories: [], data: [], district: {} };
    if (axisY && irns) {
      // Y select data
      let splitLD = axisY.value_var.split('__');
      let variable = axisY.value_var;

      // X select data
      if (splitLD.length > 1) {
        variable = splitLD[0];
        let planNum = splitLD[1];
        let planType = splitLD[2];

        if (year.value === 'MCD' && enabledHealthBenefits) {
          fetch(
            `${process.env.REACT_APP_API_URL}/mcd_hb_tabloide?select=irn,y:${variable},district_name,irn&irn=in.(${irns})&${variable}=not.is.null&plannum=eq.${planNum}&q13_plantype_p7q3=eq.${planType}&order=${variable}.desc`,
            {
              headers: {
                Authorization: "Bearer " + userToken,
                "ngrok-skip-browser-warning": true,
              },
            }
          )
            .then((response) => {
              setHistogramY("loading");
              return response.json();
            })
            .then((data) =>
              data.forEach((item) => {
                histogramYData["categories"].push(item.district_name);
                if (item.irn === districtInfo.value) {
                  histogramYData["data"].push(refDistrictHistogram(item.y, data));
                  histogramYData["district"] = item;
                } else {
                  histogramYData["data"].push(item.y);
                }
              })
            )
            .then(() => setHistogramY(histogramYData))
            .catch(() => setHistogramY("no-data"));
        } else if (enabledHealthBenefits) {
          fetch(
            `${process.env.REACT_APP_API_URL}/health_insurance_readable?select=irn,y:${variable},district_name,irn&irn=in.(${irns})&file_year=eq.${year.value}&${variable}=not.is.null&plannum=eq.${planNum}&q13_plantype_p7q3=eq.${planType}&order=${variable}.desc`,
            {
              headers: {
                Authorization: "Bearer " + userToken,
                "ngrok-skip-browser-warning": true,
              },
            }
          )
            .then((response) => {
              setHistogramY("loading");
              return response.json();
            })
            .then((data) =>
              data.forEach((item) => {
                histogramYData["categories"].push(item.district_name);
                if (item.irn === districtInfo.value) {
                  histogramYData["data"].push(refDistrictHistogram(item.y, data));
                  histogramYData["district"] = item;
                } else {
                  histogramYData["data"].push(item.y);
                }
              })
            )
            .then(() => setHistogramY(histogramYData))
            .catch(() => setHistogramY("no-data"));
        }

      } else {
        if (year.value === 'MCD') {
          fetch(
            `${process.env.REACT_APP_API_URL}/mcd_tabloide?select=irn,y:${axisY.value_var},year_y:${axisY.value_var}_yr,district_name&irn=in.(${irns})&${axisY.value_var}=not.is.null&order=${axisY.value_var}.desc`,
            {
              headers: {
                Authorization: "Bearer " + userToken,
                "ngrok-skip-browser-warning": true,
              },
            }
          )
            .then((response) => {
              setHistogramY("loading");
              return response.json();
            })
            .then((data) =>
              data.forEach((item) => {
                let distinct_year = yearList[1].value === item.year_y ? '' : ` (${item.year_y})`;

                histogramYData["categories"].push(`${item.district_name}${distinct_year}`);
                if (item.irn === districtInfo.value) {
                  histogramYData["data"].push(refDistrictHistogram(item.y, data));
                  histogramYData["district"] = item;
                } else {
                  histogramYData["data"].push(item.y);
                }
              })
            )
            .then(() => setHistogramY(histogramYData))
            .catch(() => setHistogramY("no-data"));
        } else {
          fetch(
            `${process.env.REACT_APP_API_URL}/hvd_tabloide?select=irn,y:${axisY.value_var},district_name&irn=in.(${irns})&file_year=eq.${year.value}&${axisY.value_var}=not.is.null&order=${axisY.value_var}.desc`,
            {
              headers: {
                Authorization: "Bearer " + userToken,
                "ngrok-skip-browser-warning": true,
              },
            }
          )
            .then((response) => {
              setHistogramY("loading");
              return response.json();
            })
            .then((data) =>
              data.forEach((item) => {
                histogramYData["categories"].push(item.district_name);
                if (item.irn === districtInfo.value) {
                  histogramYData["data"].push(refDistrictHistogram(item.y, data));
                  histogramYData["district"] = item;
                } else {
                  histogramYData["data"].push(item.y);
                }
              })
            )
            .then(() => setHistogramY(histogramYData))
            .catch(() => setHistogramY("no-data"));
        }
      }
    }
  }, [axisY, irns, districtInfo, year, userToken, query, enabledHealthBenefits]);

  /**
   * Updating Z axis histogram chart.
   */
  useEffect(() => {
    let histogramZData = { categories: [], data: [], district: {} };
    if (axisZ && irns) {
      // Z select data
      let splitLD = axisZ.value_var.split('__');
      let variable = axisZ.value_var;

      // X select data
      if (splitLD.length > 1) {
        variable = splitLD[0];
        let planNum = splitLD[1];
        let planType = splitLD[2];
        if (year.value === 'MCD' && enabledHealthBenefits) {
          fetch(
            `${process.env.REACT_APP_API_URL}/mcd_hb_tabloide?select=irn,z:${variable},district_name,irn&irn=in.(${irns})&${variable}=not.is.null&plannum=eq.${planNum}&q13_plantype_p7q3=eq.${planType}&order=${variable}.desc`,
            {
              headers: {
                Authorization: "Bearer " + userToken,
                "ngrok-skip-browser-warning": true,
              },
            }
          )
            .then((response) => {
              setHistogramZ("loading");
              return response.json();
            })
            .then((data) =>
              data.forEach((item) => {
                histogramZData["categories"].push(item.district_name);
                if (item.irn === districtInfo.value) {
                  histogramZData["data"].push(refDistrictHistogram(item.z, data));
                  histogramZData["district"] = item;
                } else {
                  histogramZData["data"].push(item.z);
                }
              })
            )
            .then(() => setHistogramZ(histogramZData))
            .catch(() => setHistogramZ("no-data"));
        } else if (enabledHealthBenefits) {
          fetch(
            `${process.env.REACT_APP_API_URL}/health_insurance_readable?select=irn,z:${variable},district_name,irn&irn=in.(${irns})&file_year=eq.${year.value}&${variable}=not.is.null&plannum=eq.${planNum}&q13_plantype_p7q3=eq.${planType}&order=${variable}.desc`,
            {
              headers: {
                Authorization: "Bearer " + userToken,
                "ngrok-skip-browser-warning": true,
              },
            }
          )
            .then((response) => {
              setHistogramZ("loading");
              return response.json();
            })
            .then((data) =>
              data.forEach((item) => {
                histogramZData["categories"].push(item.district_name);
                if (item.irn === districtInfo.value) {
                  histogramZData["data"].push(refDistrictHistogram(item.z, data));
                  histogramZData["district"] = item;
                } else {
                  histogramZData["data"].push(item.z);
                }
              })
            )
            .then(() => setHistogramZ(histogramZData))
            .catch(() => setHistogramZ("no-data"));
        }

      } else {
        if (year.value === 'MCD') {
          fetch(
            `${process.env.REACT_APP_API_URL}/mcd_tabloide?select=irn,z:${axisZ.value_var},year_z:${axisZ.value_var}_yr,district_name&irn=in.(${irns})&${axisZ.value_var}=not.is.null&order=${axisZ.value_var}.desc`,
            {
              headers: {
                Authorization: "Bearer " + userToken,
                "ngrok-skip-browser-warning": true,
              },
            }
          )
            .then((response) => {
              setHistogramZ("loading");
              return response.json();
            })
            .then((data) =>
              data.forEach((item) => {
                let distinct_year = yearList[1].value === item.year_z ? '' : ` (${item.year_z})`;

                histogramZData["categories"].push(`${item.district_name}${distinct_year}`);
                if (item.irn === districtInfo.value) {
                  histogramZData["data"].push(refDistrictHistogram(item.z, data));
                  histogramZData["district"] = item;
                } else {
                  histogramZData["data"].push(item.z);
                }
              })
            )
            .then(() => setHistogramZ(histogramZData))
            .catch(() => setHistogramZ("no-data"));
        } else {
          fetch(
            `${process.env.REACT_APP_API_URL}/hvd_tabloide?select=irn,z:${axisZ.value_var},district_name&irn=in.(${irns})&file_year=eq.${year.value}&${axisZ.value_var}=not.is.null&order=${axisZ.value_var}.desc`,
            {
              headers: {
                Authorization: "Bearer " + userToken,
                "ngrok-skip-browser-warning": true,
              },
            }
          )
            .then((response) => {
              setHistogramZ("loading");
              return response.json();
            })
            .then((data) =>
              data.forEach((item) => {
                histogramZData["categories"].push(item.district_name);
                if (item.irn === districtInfo.value) {
                  histogramZData["data"].push(refDistrictHistogram(item.z, data));
                  histogramZData["district"] = item;
                } else {
                  histogramZData["data"].push(item.z);
                }
              })
            )
            .then(() => setHistogramZ(histogramZData))
            .catch(() => setHistogramZ("no-data"));
        }
      }
    }
  }, [axisZ, irns, districtInfo, year, userToken, query, enabledHealthBenefits]);

  // Updating Scatter Chart.
  useEffect(() => {
    if (axisX && axisY && axisZ && irns) {
      requestAxis(enabledHealthBenefits, 'x', axisX.value_var, districtInfo, irns, year, setScatterX);
      requestAxis(enabledHealthBenefits, 'y', axisY.value_var, districtInfo, irns, year, setScatterY);
      requestAxis(enabledHealthBenefits, 'z', axisZ.value_var, districtInfo, irns, year, setScatterZ);
    }
  }, [axisX, axisY, axisZ, irns, districtInfo, year, enabledHealthBenefits]);

  // Updating Scatter Chart.
  useEffect(() => {
    if (scatterX && scatterY && scatterZ) {
      let xy = mergeArrayObjects({ arrX: scatterX, arrY: scatterY, id: "irn" });
      let xyz = mergeArrayObjects({ arrX: xy, arrY: scatterZ, id: "irn" });
      setScatterData(xy);
      setBubbleData(xyz);
    }
  }, [scatterX, scatterY, scatterZ]);

  useEffect(() => {
    if (irns && Object.keys(year).length > 0) {
      //Getting data Map for group
      if (year.value === 'MCD') {
        simpleFetch(
          `${process.env.REACT_APP_API_URL}/hvd_polygons_mcd?irn=in.(${irns})`
        ).then((polygons) => {
          setMapViewData(
            polygons.map((item) => {
              return {
                ...item,
                color: "#4646FF",
              };
            })
          );
        });
      } else {
        simpleFetch(
          `${process.env.REACT_APP_API_URL}/hvd_polygons?irn=in.(${irns})&file_year=eq.${year.value}`
        ).then((polygons) => {
          setMapViewData(
            polygons.map((item) => {
              return {
                ...item,
                color: "#4646FF",
              };
            })
          );
        });
      }
    }
  }, [irns, year]);

  let zAxisDefinition = "Select a data point to display as a bubble by size on the bottom graph";
  let slideHelpText = "Slide to select the range you wish to compare";

  useEffect(() => {
    if (axisX && axisY !== undefined) {
      window._paq.push(["trackGoal", 7]);
    }
  }, [axisX, axisY]);

  useEffect(() => {
    if (query.get("shared")) {
      simpleFetch(
        `${process.env.REACT_APP_API_URL}/custom_boards?uuid=eq.` + query.get("shared")).then((customBoards) => {
          let boardRetrieve = customBoards[0];
          if (
            (boardRetrieve.available_users_share &&
              boardRetrieve.available_users_share.some(
                (userShare) => userShare.value === user.email
              )) ||
            boardRetrieve.created_by === user.email
          ) {
            let unsorted = customBoards[0].data;
            // created_at string to date object
            Object.keys(unsorted).forEach(key => {
              return unsorted[key].created_at = new Date(unsorted[key].created_at);
            });
            let sortedDates = Object.keys(unsorted).sort(function (a, b) {
              return unsorted[b].created_at - unsorted[a].created_at
            })
            let lastVersion = sortedDates[0];
            let boardRetrieve =
              "irns" in customBoards[0].data
                ? customBoards[0].data
                : customBoards[0].data[lastVersion];
            setExistingBoard(customBoards[0]);
            boardName.current = customBoards[0].label;

            if (customBoards[0]["available_users_share"]) {
              setShareWith(customBoards[0]["available_users_share"]);
            }
            if (boardRetrieve.referenceDistrict) {
              setDistrictInfo(boardRetrieve.referenceDistrict);
            } else {
              setDistrictInfo({
                value: 45187,
                label: "Ada Ex Vill SD, Hardin (045187)",
              });
            }

            setBoardVersion(
              boardRetrieve.groupCount,
              boardRetrieve.year,
              boardRetrieve.irns,
              boardRetrieve.groupType,
              boardRetrieve.groupInfo,
              boardRetrieve.sliderRanges.xRange,
              boardRetrieve.axisVars.axisX,
              boardRetrieve.statsVariables.statsVariableX,
              boardRetrieve.histogramsData.histogramX,
              boardRetrieve.sliderRanges.yRange,
              boardRetrieve.axisVars.axisY,
              boardRetrieve.statsVariables.statsVariableY,
              boardRetrieve.histogramsData.histogramY,
              boardRetrieve.sliderRanges.zRange,
              boardRetrieve.axisVars.axisZ,
              boardRetrieve.statsVariables.statsVariableZ,
              boardRetrieve.histogramsData.histogramZ
            );
          } else {
            navigate("/AccessDenied", { replace: true });
          }
        });
    }
    // Build board on load if no query found.
    if (!query.get("shared") && userToken) {
      // Cleaning existing board data if no query detected.
      setExistingBoard()
      setLastVersion();
      setAxisX(null);
      setAxisY(null);
      setAxisZ(null);
      buildOnLoad({ user: user, callback: setBoardData, token: userToken });
    }
  }, [query, navigate, user, userToken]);

  useEffect(() => {
    if (boardData) {
      // Reset filters on data update.
      setAxisX(null);
      setAxisY(null);
      setAxisZ(null);
      // Updating board info.
      setDistrictInfo(boardData.referenceDistrict);
      setYear(boardData.year);
      setGroupType(boardData.groupType);
      setGroupInfo(boardData.groupInfo);
      setIrns(boardData.irns);
      setGroupCount(boardData.groupCount);
    }
  }, [boardData]);

  // A message to be displayed when X || Y axis are null.
  const [axisNull, setAxisNull] = useState();

  useEffect(() => {
    let tempAxis = null;
    if (axisX && statsVariableX && !validRange({ range: statsVariableX })) {
      tempAxis = { axis: 'X', var: axisX.label }
    }
    if (axisY && statsVariableY && !validRange({ range: statsVariableY }) && !tempAxis) {
      tempAxis = { axis: 'Y', var: axisY.label }
    }
    if (axisZ && statsVariableZ && !validRange({ range: statsVariableZ }) && !tempAxis) {
      tempAxis = { axis: 'Z', var: axisZ.label }
    }
    setAxisNull(tempAxis);
  }, [statsVariableX, statsVariableY, statsVariableZ, axisX, axisY, axisZ])

  const topContentElement = (
    <Box className={"board-actions"} sx={BoardActionsStyles}>
      <Grid container className={"board-actions__wrapper"} spacing={2}>
        <Grid item xs={12} lg={3} className={"board-actions__board-menu"} display="flex">
          <Tooltip title="Filters">
            <Button
              id="button-filters"
              aria-controls={"menu-filters"}
              aria-haspopup="true"
              aria-expanded={openFilters ? "true" : "false"}
              variant="contained"
              onClick={clickFilters}
              color={"grape"}
              className="board-menu__filters"
            >
              <FilterAltOutlinedIcon />
              Filters
            </Button>
          </Tooltip>
          <Menu
            id="menuFilters"
            MenuListProps={{
              "aria-labelledby": "button-filters",
            }}
            anchorEl={btnFilter}
            open={openFilters}
            onClose={closeFilters}
            sx={MenuBoxStyles}
          >
            <MenuItem disableRipple>
              <BoardBuilder
                groupEnabled={true}
                yearEnabled={true}
                boardData={setBoardData}
                onSubmit={() => handleFilter()}
              />
            </MenuItem>
          </Menu>
          {enabledShare && (
            <>
              <Tooltip title="Save Board">
                <span>
                  <Button
                    id="savedBoard"
                    aria-controls={"menu-saved"}
                    aria-haspopup="true"
                    aria-expanded={openSaved ? "true" : "false"}
                    variant="outlined"
                    color="purple"
                    disabled={!districtInfo}
                    onClick={clickSaved}
                    className={"board-menu__save-board"}
                  >
                    <SaveOutlinedIcon />
                  </Button>
                </span>
              </Tooltip>
              <Menu
                id="menuSaved"
                MenuListProps={{
                  "aria-labelledby": "button-saved",
                }}
                anchorEl={btnSaved}
                open={openSaved}
                onClose={closeSaved}
                sx={MenuBoxStyles}
              >
                <MenuItem disableRipple>
                  {groupCount && Object.keys(year).length > 0 && (
                    <SaveBoardForm
                      type={"explorer"}
                      boardData={{
                        referenceDistrict: districtInfo,
                        irns: irns,
                        groupType: groupType,
                        groupInfo: groupInfo,
                        groupCount: groupCount,
                        year: { value: year.value, label: year.value },
                        axisVars: {
                          axisX: axisX,
                          axisY: axisY,
                          axisZ: axisZ,
                        },
                        sliderRanges: {
                          xRange: xCustomRange || statsVariableX,
                          yRange: yCustomRange || statsVariableY,
                          zRange: zCustomRange || statsVariableZ,
                        },
                        histogramsData: {
                          histogramX: histogramX,
                          histogramY: histogramY,
                          histogramZ: histogramZ,
                        },
                        statsVariables: {
                          statsVariableX: statsVariableX,
                          statsVariableY: statsVariableY,
                          statsVariableZ: statsVariableZ,
                        },
                      }}
                      endpoint={`${process.env.REACT_APP_API_URL}/custom_boards`}
                      //layout={true}
                      customBoard={existingBoard}
                      //onChange={setBoardVersion}
                      onSave={closeSaved}
                    />
                  )}
                </MenuItem>
              </Menu>
              <Tooltip title="Share Board">
                <span>
                  <Button
                    id="shareBoard"
                    aria-controls={"menu-shared"}
                    aria-haspopup="true"
                    aria-expanded={openShared ? "true" : "false"}
                    variant="outlined"
                    color="purple"
                    disabled={
                      !existingBoard ||
                      existingBoard.created_by !== user.email
                    }
                    onClick={clickShared}
                    className={"share-board"}>
                    <ShareOutlinedIcon />
                  </Button>
                </span>
              </Tooltip>
              <Menu
                id="menuShared"
                MenuListProps={{
                  "aria-labelledby": "button-shared",
                }}
                anchorEl={btnShared}
                open={openShared}
                onClose={closeShared}
                sx={MenuBoxStyles}
              >
                <MenuItem disableRipple>
                  {usersFormat && (
                    <Grid container spacing={2} textAlign="center">
                      <Grid item sm={12} display="flex">
                        <Autocomplete
                          sx={{
                            '& .MuiAutocomplete-tag': {
                              backgroundColor: '#808080',
                              color: "#ffffff"
                            },
                          }}
                          multiple
                          options={usersFormat}
                          id={"shared-with"}
                          defaultValue={shareWith}
                          onChange={(e, newValue) => {
                            setShareWith(newValue);
                          }}
                          fullWidth
                          noOptionsText={'Loading...'}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item sm={12} display="flex">
                        <Button
                          variant="contained"
                          color="grape"
                          onClick={() => shareWithUsers()}
                        >
                          Share with users
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </MenuItem>
              </Menu>
            </>
          )}
        </Grid>
        {existingBoard && (
          <>
            <Grid item display="flex" className="board-actions__board-name" xs={12} md={6} lg={4}>
              {action === "edit-name" ? (
                <Grid item container component={"form"} spacing={0.5} xs={12} display={"flex"} onSubmit={changeName}>
                  <Grid item xs={10} className="board-name--edit">
                    <TextField
                      autoComplete="off"
                      className="form-field form-field--group-name"
                      id="BoardName"
                      defaultValue={boardName.current}
                      onChange={(e) => (boardName.current = e.target.value.trim())}
                      fullWidth
                      variant="outlined"
                      label="Board Name"
                      required
                      sx={InputEditStyles}
                      inputProps={{
                        minLength: 3,
                        pattern: "^[^\\s](?:(?!\\s{2,}).)*[^\\s]$",
                        title: "Board name must start and end with a letter or number, and can't contain consecutive spaces"
                      }}
                    />
                  </Grid>
                  <Grid item className="board__edit-actions" xs={2}>
                    <Button
                      variant="contained"
                      size="small"
                      color="grape"
                      className={"button-rename"}
                      type={"submit"}
                    >
                      Rename
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      color="secondary"
                      onClick={() => setAction("")}
                      className={"button-cancel"}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              ) : (
                  <>
                    <Grid item className="board-name" xs={10}>
                      <label className="board-name__label">Board Name</label>
                      {existingBoard.label}
                    </Grid>
                    <Grid className="button-edit" item xs={2}>
                      <Button
                        aria-label="edit name"
                        className="edit-name"
                        onClick={() => {
                          boardName.current = existingBoard.label;
                          setAction("edit-name");
                        }}
                      >
                        <EditIcon style={{ color: "#221349" }} />
                      </Button>
                    </Grid>
                  </>
                )}
            </Grid>
            <Grid item display="flex" className="board-actions__board-version" xs={12} md={6} lg={5}>
              {action === "edit-version" && activeVersion ? (
                <Grid item container component={"form"} spacing={0.5} xs={12} display={"flex"} onSubmit={changeVersion}>
                  <Grid item xs={10} className="board-version--edit">
                    <TextField
                      autoComplete="off"
                      className="form-field form-field--group-name"
                      id="VersionName"
                      defaultValue={boardVersion.current}
                      onChange={(e) => boardVersion.current = e.target.value.trim()}
                      fullWidth
                      variant="outlined"
                      label="Version Name"
                      required
                      sx={InputEditStyles}
                      inputProps={{
                        minLength: 3,
                        pattern: "^[^\\s](?:(?!\\s{2,}).)*[^\\s]$",
                        title: "Version name must start and end with a letter or number, and can't contain consecutive spaces"
                      }}
                    />
                  </Grid>
                  <Grid item xs={2} className="board__edit-actions">
                    <Button
                      className="button-rename"
                      variant="contained"
                      size="small"
                      color="grape"
                      type={"submit"}
                    >
                      Rename
                    </Button>
                    <Button
                      className="button-cancel"
                      variant="contained"
                      size="small"
                      color="secondary"
                      onClick={() => setAction("")}
                    >
                      Cancel
                    </Button>
                  </Grid>
                </Grid>
              ) : (
                  (activeVersion && existingBoard.data[activeVersion.value] && existingBoard.data[activeVersion.value]["done_by"] === user.email) && (
                    <>
                      <Grid item xs={10}>
                        <Autocomplete
                          id="data-version"
                          options={sortedVersions}
                          onChange={(e, newValue) => {
                            if (newValue) {
                              handleChange(newValue);
                            }
                          }}
                          defaultValue={activeVersion}
                          noOptionsText={'Loading...'}
                          renderInput={(params) => (<TextField{...params} label="Board version" />
                          )}
                        />
                      </Grid>
                      <Grid item xs={2} className={"button-edit"}>
                        <Button
                          aria-label="edit version"
                          size="large"
                          className={"edit-version"}
                          onClick={() => {
                            setAction("edit-version");
                            boardVersion.current = activeVersion.value;
                          }}
                        >
                          <EditIcon style={{ color: "#221349" }} />
                        </Button>
                      </Grid>
                    </>
                  )
                )}
            </Grid>
          </>
        )}
        {groupInfo && groupCount && (
          <Grid item xs={12} lg={existingBoard ? 12 : 9} className="group-counter" sx={BoardGroupCounter}>
            <div className="group-counter__wrapper">
              <div className="group-counter__versus">{`${districtInfo.label} - vs -`} <GroupDisplay groupData={{ groupInfo: groupInfo, groupType: groupType }} /></div>
              <div className="group-counter__result">{`Year: ${year.value === "MCD"
                ? `2026 (${year.label})`
                : year.label
                } | ${groupCount} districts in the comparison group.`}</div>
            </div>
          </Grid>
        )}
      </Grid>
    </Box>
  );

  return (
    <LayoutPage
      pageTitle={"District Explorer"}
      description="Build custom groups based on filters"
      type="dashboard"
      customClass="district-explorer"
      topContent={topContentElement}
    >
      <Grid container spacing={2} columns={12} className="content__top" sx={ExplorerStyles}>
        {
          mapViewData && Object.keys(year).length > 0 && (
            <Grid item xs={12} md={4} className="section section--district-map">
              <MapView
                data={mapViewData}
                districtIrn={districtInfo.value}
                height="100%"
                zoom={6.5}
              />
            </Grid>)
        }
        {
          Object.keys(year).length > 0 && (
            <Grid item xs={12} md={8}>
              {(axisX || axisY || axisZ) && (
                <div className="slides-info">
                  <TooltipCustom
                    text={slideHelpText}
                    aria-label={slideHelpText}
                    className={"slides-tooltip"}
                  />
                </div>
              )}
              <div className="data-filters__item">
                <Autocomplete
                  id={"x-axis"}
                  value={axisX}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  className={"form-select"}
                  options={DomainGroup}
                  fullWidth={true}
                  onChange={(event, newValue) => {
                    // Matomo code.
                    if (newValue) {
                      window._paq.push([
                        "trackEvent",
                        "Board DistrictExplorer",
                        "Clicked: X Axis",
                        `Selected: ${newValue.label}`,
                      ]);
                      setXCustomRange();
                      setAxisX(null);
                      setVarZEnabled(null)
                      setTimeout(() => {
                        setAxisX(newValue);
                      }, 1000);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="X Axis (Horizontal)"
                      required={true}
                    />
                  )}
                />
                {axisX && statsVariableX && xCustomRange && (
                  <div className="var__range-slider">
                    <RangeSlider
                      ranges={statsVariableX}
                      values={xCustomRange}
                      id={"x-axis"}
                      unit={axisX.var_type}
                      onChange={(val) => updateRanges(val, setXCustomRange)}
                      markData={
                        histogramX?.district
                          ? [
                            {
                              label: histogramX.district.district_name,
                              value: histogramX.district.x,
                            },
                          ]
                          : null
                      }
                    />
                  </div>
                )}
              </div>
              <div className="data-filters__item">
                <Autocomplete
                  id={"y-axis"}
                  value={axisY}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  className={"form-select"}
                  options={DomainGroup}
                  fullWidth={true}
                  onChange={(event, newValue) => {
                    // Matomo code.
                    if (newValue) {
                      window._paq.push([
                        "trackEvent",
                        "Board DistrictExplorer",
                        "Clicked: Y Axis",
                        `Selected: ${newValue.label}`,
                      ]);
                      setYCustomRange();
                      setAxisY(null);
                      setVarZEnabled(null)
                      setTimeout(() => {
                        setAxisY(newValue);
                      }, 1000);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={"Y Axis (Vertical)"}
                      required={true}
                    />
                  )}
                />
                {axisY && statsVariableY && yCustomRange && (
                  <div className="var__range-slider">
                    <RangeSlider
                      ranges={statsVariableY}
                      values={yCustomRange}
                      id={"y-axis"}
                      unit={axisY.var_type}
                      onChange={(val) => updateRanges(val, setYCustomRange)}
                      markData={
                        histogramY?.district
                          ? [
                            {
                              label: histogramY.district.district_name,
                              value: histogramY.district.y,
                            },
                          ]
                          : null
                      }
                    />
                  </div>
                )}
              </div>
              <div className="data-filters__item z-data-filter">
                <span
                  style={{ margin: "-18px 0px" }}
                  className={"help-tooltip z-axis-tooltip"}
                >
                  <TooltipCustom
                    text={zAxisDefinition}
                    aria-label={zAxisDefinition}
                  />
                </span>
                <Autocomplete
                  id={"z-axis"}
                  value={axisZ}
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  className="form-select"
                  options={DomainGroup}
                  fullWidth={true}
                  onChange={(event, newValue) => {
                    // Matomo code.
                    if (newValue) {
                      window._paq.push([
                        "trackEvent",
                        "Board DistrictExplorer",
                        "Clicked: Z Axis",
                        `Selected: ${newValue.label}`,
                      ]);
                      // Cleaning hooks before update
                      setBubbleData();
                      setZCustomRange();
                      setAxisZ(null);
                      setVarZEnabled(null)
                      setTimeout(() => {
                        setAxisZ(newValue);
                      }, 1000);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={"Bubble size"}
                      required={true}
                    />
                  )}
                />
                {axisZ && statsVariableZ && zCustomRange && (
                  <div className="var__range-slider">
                    <RangeSlider
                      ranges={statsVariableZ}
                      values={zCustomRange}
                      id={"z-axis"}
                      unit={axisZ.var_type}
                      onChange={(val) => updateRanges(val, setZCustomRange)}
                      markData={
                        histogramZ?.district
                          ? [
                            {
                              label: histogramZ.district.district_name,
                              value: histogramZ.district.z,
                            },
                          ]
                          : null
                      }
                    />
                  </div>
                )}
              </div>
              <div className="extra-filters__actions">
                <Button
                  variant={"contained"}
                  style={{ backgroundColor: "#221349", color: "#fff" }}
                  className="reset-data"
                  onClick={() =>
                    clearHooks(
                      setHistogramX,
                      setAxisX,
                      setHistogramY,
                      setAxisY,
                      setHistogramZ,
                      setAxisZ,
                      setScatterData,
                      setBubbleData
                    )
                  }
                >
                  Clear axis
                </Button>
              </div>
            </Grid>
          )}
        { // Axis X lollipop chart.
          (histogramX && axisX) &&
          <Grid item xs={12} lg={4} className="section section--histogram-x">
            <LollipopChart
              data={histogramX}
              title={axisX.label}
              description={axisX.description}
              id={"histogram-x"}
              ranges={statsVariableX}
              customRanges={xCustomRange}
            />
            <div className="chart-footer-data">
              {xFooterData && (
                <div className="chart-footer__var-distribution">
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel-x-distribution-content`}
                      id={`panel-x-distribution-header`}
                      className="accordion-summary"
                    >
                      <strong>See descriptive stats</strong>
                    </AccordionSummary>
                    <AccordionDetails className="accordion-details">
                      <p>
                        {axisX.label} has <b>{xFooterData.points}</b> records
                        with: max <b>{xFooterData.max}</b>, min{" "}
                        <b>{xFooterData.min}</b>, mean <b>{xFooterData.mean}</b>
                        , median <b>{xFooterData.median}</b>, mode{" "}
                        <b>{xFooterData.mode}</b>, 1st quartile{" "}
                        <b>{xFooterData["1st quartile"]}</b>, 3rd quartile{" "}
                        <b>{xFooterData["3rd quartile"]}</b>, and{" "}
                        <b>{xFooterData.nulls}</b> nulls.
                      </p>
                    </AccordionDetails>
                  </Accordion>
                </div>
              )}
              <ApaReferenceAccordion apaData={axisX} />
            </div>
          </Grid>
        }
        { // Axis Y lollipop chart.
          (histogramY && axisY) &&
          <Grid item xs={12} lg={4} className="section section--histogram-y">
            <LollipopChart
              data={histogramY}
              title={axisY.label}
              description={axisY.description}
              id={"histogram-y"}
              ranges={statsVariableY}
              customRanges={yCustomRange}
            />
            <div className="chart-footer-data">
              {yFooterData && (
                <div className="chart-footer__var-distribution">
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel-y-distribution-content`}
                      id={`panel-y-distribution-header`}
                      className="accordion-summary"
                    >
                      <strong>See descriptive stats</strong>
                    </AccordionSummary>
                    <AccordionDetails className="accordion-details">
                      <p>
                        {axisY.label} has <b>{yFooterData.points} </b> records
                        with: max <b>{yFooterData.max}</b>, min{" "}
                        <b>{yFooterData.min}</b>, mean <b>{yFooterData.mean}</b>
                        , median <b>{yFooterData.median}</b>, mode{" "}
                        <b>{yFooterData.mode}</b>, 1st quartile{" "}
                        <b>{yFooterData["1st quartile"]}</b>, 3rd quartile{" "}
                        <b>{yFooterData["3rd quartile"]}</b>, and{" "}
                        <b>{yFooterData.nulls}</b> nulls.
                      </p>
                    </AccordionDetails>
                  </Accordion>
                </div>
              )}
              <ApaReferenceAccordion apaData={axisY} />
            </div>
          </Grid>
        }
        { // Axis Z lollipop chart.
          (histogramZ && axisZ) &&
          <Grid item xs={12} lg={4} className="section section--histogram-z">
            <LollipopChart
              data={histogramZ}
              title={axisZ.label}
              description={axisZ.description}
              id={"histogram-z"}
              ranges={statsVariableZ}
              customRanges={zCustomRange}
            />
            <div className="chart-footer-data">
              {zFooterData && (
                <div className="chart-footer__var-distribution">
                  <Accordion>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel-z-distribution-content`}
                      id={`panel-z-distribution-header`}
                      className="accordion-summary"
                    >
                      <strong>See descriptive stats</strong>
                    </AccordionSummary>
                    <AccordionDetails className="accordion-details">
                      <p>
                        {axisZ.label} has <b>{zFooterData.points}</b> records
                        with: max <b>{zFooterData.max}</b>, min{" "}
                        <b>{zFooterData.min}</b>, mean <b>{zFooterData.mean}</b>
                        , median <b>{zFooterData.median}</b>, mode{" "}
                        <b>{zFooterData.mode}</b>, 1st quartile{" "}
                        <b>{zFooterData["1st quartile"]}</b>, 3rd quartile{" "}
                        <b>
                          {
                            zFooterData[
                            "3rd q, and <b>{yFooterData.nulls}</b> nulls.uartile"
                            ]
                          }
                        </b>
                        , and <b>{zFooterData.nulls}</b> nulls.
                      </p>
                    </AccordionDetails>
                  </Accordion>
                </div>
              )}
              <ApaReferenceAccordion apaData={axisZ} />
            </div>
          </Grid>
        }
        { // Scatter plot and Bubble chart.
          (scatterData && axisX && axisY && axisZ) && (
            <Grid component={Paper} item xs={12} className="section section--scatter-data" style={{ padding: 10, margin: 10 }}>
              <Box className="chart-options">
                <div className="chart-control">
                  <Button
                    variant={varZEnabled ? "outlined" : "contained"}
                    onClick={() => {
                      setVarZEnabled(!varZEnabled)
                    }}
                    color="purple"
                    disabled={!!axisNull}
                  >
                    Turn {varZEnabled ? "off" : "on"} Bubble size
                  </Button>
                  {
                    axisNull &&
                    <TooltipCustom text={`Not available. The variable ${axisNull.var} is NULL`} />
                  }
                </div>
                <div className="chart-message">
                  {
                    (axisNull && axisNull.axis !== 'Z')
                      ? <p>The variable <strong>{axisNull.var}</strong> in {axisNull.axis} axis <strong>is NULL</strong></p>
                      : <p>Displaying <strong>{varZEnabled ? bubbleData.length : scatterData.length} districts</strong> in the chart.</p>
                  }
                </div>
              </Box>
              <Box style={{ display: varZEnabled ? "block" : "none" }}>
                {
                  bubbleData &&
                  <BubbleChart
                    options={bubbleData}
                    x={axisX}
                    y={axisY}
                    z={axisZ}
                    xCustomRange={xCustomRange}
                    yCustomRange={yCustomRange}
                    year={year.value}
                  />
                }
              </Box>
              <Box style={{ display: !varZEnabled ? "block" : "none" }}>
                <ScatterChart
                  options={scatterData}
                  x={axisX}
                  y={axisY}
                  xCustomRange={xCustomRange}
                  yCustomRange={yCustomRange}
                />
              </Box>
            </Grid>
          )}
      </Grid>
      <ReportButtons
        boardType={"Board Explorer"}
        collectedData={{
          referenceDistrict: districtInfo,
          irns: irns,
          groupType: groupType,
          groupInfo: groupInfo,
          groupCount: groupCount,
          year: { value: year.value, label: year.value },
          axisVars: { axisX: axisX, axisY: axisY, axisZ: axisZ },
          sliderRanges: {
            xRange: xCustomRange || statsVariableX,
            yRange: yCustomRange || statsVariableY,
            zRange: zCustomRange || statsVariableZ,
          },
          histogramsData: {
            histogramX: histogramX,
            histogramY: histogramY,
            histogramZ: histogramZ,
          },
          statsVariables: {
            statsVariableX: statsVariableX,
            statsVariableY: statsVariableY,
            statsVariableZ: statsVariableZ,
          },
        }}
      />
      <Snackbar
        className="statusMessage"
        open={displayStatus}
        autoHideDuration={6000}
        onClose={() => setDisplayStatus(false)}>
        <Alert onClose={() => setDisplayStatus(false)} variant="filled" severity={`${status?.type ?? 'success'}`}>{status?.message}</Alert>
      </Snackbar>
    </LayoutPage>
  );
}

export default DistrictExplorer;
